// extracted by mini-css-extract-plugin
module.exports = {"attachment":"attachment___g5t0I","remove":"remove___3ONLb","filename":"filename___1zkwR"};